<template>
  <section class="pt-3">
    <div class="d-flex justify-content-start text-small">
      <div class="flex-fill">
        เลือกภาษาที่ต้องการแปล
      </div>
      <div class="input-group mt-2">
          <select v-model="language" class="form-control">
            <option value="th">ภาษาไทย</option>
            <option value="en">ภาษาอังกฤษ</option>
            <option value="my-MM">ภาษาพม่า</option>
            <option value="lo-LA">ภาษาลาว</option>
            <option value="km-KH">ภาษากัมพูชา</option>
          </select>
        </div>
    </div>
    <div class="d-flex justify-content-start align-items-center">
      <div class="flex-fill ">
        <div class="form-group mb-4">
          <textarea
            type="text"
            class="form-control mt-4"
            placeholder="มีอะไรให้ฉันแปลบ้างไหม?"
            v-model="message"
            rows="3"
            required
          />
        </div>
      </div>
      <div class="pl-2" v-if="message">
        <button class="btn btn-light btn-circle btn-sm" @click="clearMessage()">
          <i class="fas fa-times" />
        </button>
      </div>
      <div class="pl-2">
        <button class="btn btn-primary m-0" @click="sendMessage">
          <i class="fa-solid fa-paper-plane"></i>
        </button>
      </div>
    </div>
    <transition name="fade">
      <div class="mt-3" v-if="isTranslate">
        <span>
          <i class="fa-solid fa-xl fa-compact-disc fa-flip"></i>&nbsp;&nbsp;AI กำลังประมวลผล...
        </span>
      </div>
      <div class="card shadow-sm mt-3" v-if="translateMessage">
        <div class="card-body text-small bg-claude p-3">
          <!-- <div class="text-right">
            <a href="" class="text-secondary" @click.prevent="textCompletion = null">
              <i class="fas fa-times-circle"></i>
            </a>
          </div> -->
          <div v-html="translateMessage"></div><button v-if="isReply" class="btn btn-primary m-0" @click="replyTranslate(translateMessage)">Reply to chat</button>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  props: {
    response: Object
  },
  data () {
    return {
      language: 'th',
      message: '',
      isTranslate: false,
      isReply: true,
      showTranslate: false,
      translateMessage: null
    }
  },
  computed: {
    ...mapState('aiAssistant', ['customerMessage'])
  },
  watch: {
    customerMessage () {
      // console.log('check customerMessage', this.customerMessage)
      if (this.customerMessage) {
        this.message = this.customerMessage
      }
    }
  },
  methods: {
    clearMessage () {
      this.message = ''
      this.translateMessage = null
    },
    async sendMessage () {
      this.showTranslate = true
      this.isTranslate = true
      this.isReply = true
      this.translateMessage = null
      if (this.message === '') {
        this.translateMessage = 'กรุณากรอกข้อความที่ต้องการแปล'
        this.isTranslate = false
        this.isReply = false
      }
      // console.log('check message', this.message)
      const url = `/ai-assistant/translate-lang`
      const { data } = await axios.post(url, {
        inputText: this.message,
        targetLang: this.language
      })
      this.isTranslate = false
      console.log(data)
      if (data) {
        this.translateMessage = data.result.translation
      }
    },
    replyTranslate (message) {
      // console.log(message)
      this.isReply = false
      this.$store.commit('aiAssistant/SET_REPLY_TRANSLATE_AI', message)
    }
  }
}
</script>
<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.bg-claude {
  background-color: #F1F8E9;
}
</style>
